import { Header } from '@giffgaff/fe-design-system-ui'
import { customEvent } from '@fe-toolkit/eventing'

import TamaguiScope from './TamaguiScope'

import type { HeaderAnalyticsEvent } from '@giffgaff/fe-design-system-ui'

// feds-ui emits lowercase `type` and `interaction`, but the
// @fe-toolkit/eventing 0.9 schema only accepts title case. GTM lowercases the
// values before sending them to Snowplow.
const trackHeaderEvent = ({ eventName, eventData }: HeaderAnalyticsEvent) => {
  customEvent(eventName, { ...eventData, type: 'List', interaction: 'Click' })
}

export default function BrandRefreshHeader({
  username,
  isBlackFriday = false,
  isBlackFridayPrereg = false,
}: {
  username?: string
  isBlackFriday?: boolean
  isBlackFridayPrereg?: boolean
}) {
  return (
    <TamaguiScope styleId="fallback-header-css">
      <header>
        <Header
          isBlackFriday={isBlackFriday || isBlackFridayPrereg}
          username={username}
          onAnalyticsEvent={trackHeaderEvent}
        />
      </header>
    </TamaguiScope>
  )
}
